export default "__VITE_ASSET__DG1aOV5L__"